/**
 * Visit freshness configuration.
 *
 * Thresholds (in days) determine how the "Last Visit" column is colored.
 * A visit that happened within `recentDays` is considered fresh/good;
 * between `recentDays` and `staleDays` it is stale (warning); beyond
 * `staleDays` it is considered lost (danger).
 */

export const visitFreshness = {
  recentDays: 28,
  // Visit within this many days is considered recent (green).

  staleDays: 60,
  // Visit older than recentDays but within this many days is stale (amber).
  // Beyond staleDays the client is considered lost (red).
} as const
